module.exports = __webpack_public_path__ + "img/near_me.a3f82753.svg";